// Shared seed-data signal.
//
// SeedPill — small chip rendered next to a page meta line.
// SeedBanner — full callout, sits below the page-head, with a make-real hint
// pointing at the file or wiring step the operator can take to flip the
// surface from oracle/sample → live.
//
// Use both on every surface fed by bundled JSON or synthetic data so it's
// always obvious to the operator what's painted vs. live.

export function SeedPill({ label = "SEED DATA" }: { label?: string }) {
  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 6,
        marginLeft: 12,
        padding: "3px 9px",
        borderRadius: 6,
        fontFamily: "var(--font-mono)",
        fontSize: 9,
        letterSpacing: "0.18em",
        fontWeight: 700,
        color: "var(--amber)",
        background: "rgba(246, 177, 60, 0.08)",
        border: "1px solid rgba(246, 177, 60, 0.32)",
        verticalAlign: "middle",
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          background: "var(--amber)",
        }}
      />
      {label}
    </span>
  );
}

interface BannerProps {
  /** One-line "what this surface would do live". */
  what: string;
  /** Concrete next step — paths, commands, command IDs. */
  howToReal: React.ReactNode;
}

export function SeedBanner({ what, howToReal }: BannerProps) {
  return (
    <div
      style={{
        padding: "12px 16px",
        background: "rgba(246, 177, 60, 0.08)",
        border: "1px solid rgba(246, 177, 60, 0.28)",
        borderLeft: "3px solid var(--amber)",
        borderRadius: 8,
        fontSize: 12.5,
        color: "var(--ink-dim)",
        marginBottom: 18,
        lineHeight: 1.55,
      }}
    >
      <strong style={{ color: "var(--amber)" }}>Seed data shown.</strong> {what}{" "}
      <span style={{ color: "var(--ink-faint)" }}>{howToReal}</span>
    </div>
  );
}
